<template>
  <section class="lk-step">
    <h2 class="lk-q">Wo bist du zu Hause?</h2>
    <p class="lk-sub">Damit wir dir passende Profile aus deiner Region zeigen können.</p>
    <label
      class="field-label"
      for="lk-loc"
    >Ort oder PLZ</label>
    <div class="ac-wrap">
      <input
        id="lk-loc"
        type="text"
        class="signup-input"
        :value="locationLabel"
        placeholder="z. B. Berlin oder 10115"
        autocomplete="off"
        @input="onLocInput"
        @keydown="onLocKeydown"
      />
      <div
        class="ac-list"
        :class="{ open: acOpen }"
        role="listbox"
      >
        <div
          v-if="acOpen && !acMatches.length"
          class="ac-item"
        >
          <span class="pin">·</span>
          <span
            class="nm"
            style="color: var(--ink-mute)"
          >Keine Treffer</span>
        </div>
        <div
          v-for="l in acMatches"
          :key="l.id"
          class="ac-item"
          role="option"
          @click="pickLocation(l)"
        >
          <span
            v-if="flagComponent(l.country_code)"
            class="flag"
            :class="'flag-' + l.country_code"
            aria-hidden="true"
          ><component :is="flagComponent(l.country_code)" /></span>
          <span class="nm">{{ l.city }}</span>
          <span class="rg">{{ l.city }}{{ l.zip_code ? ' · ' + l.zip_code : '' }}</span>
        </div>
      </div>
    </div>
    <div class="helper">{{ locHelper }}</div>
  </section>
</template>

<script>
import FlagAt from '../../icons/FlagAt.vue';
import FlagCh from '../../icons/FlagCh.vue';
import FlagDe from '../../icons/FlagDe.vue';
import { FALLBACK_LOCATIONS, filterLocations } from '../kennenlernenLeadFunnel';

export default {
  name: 'LeadFunnelStepLocation',
  components: { FlagAt, FlagCh, FlagDe },
  props: {
    locationId: { default: null },
    locationLabel: { type: String, default: '' },
  },
  data() {
    return {
      locHelper: 'Wähle einen Vorschlag aus der Liste.',
      acOpen: false,
      acMatches: [],
      locations: [],
      locationsLoaded: false,
      locationsLoading: null,
      acTimer: null,
    };
  },
  watch: {
    locationId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.locHelper = 'Ausgewählt: ' + this.locationLabel;
        }
      },
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick);
    clearTimeout(this.acTimer);
  },
  methods: {
    flagComponent(cc) {
      if (cc === 'at') {
        return 'FlagAt';
      }
      if (cc === 'ch') {
        return 'FlagCh';
      }
      if (cc === 'de') {
        return 'FlagDe';
      }
      return null;
    },
    onLocInput(e) {
      const q = e.target.value;
      this.$emit('update:locationLabel', q);
      this.$emit('update:locationId', null);
      this.locHelper = 'Wähle einen Vorschlag aus der Liste.';
      clearTimeout(this.acTimer);
      if (!q || q.length < 2) {
        this.acOpen = false;
        this.acMatches = [];
        return;
      }
      this.acTimer = setTimeout(() => {
        this.loadLocations().then(() => {
          this.acMatches = filterLocations(this.locations, q);
          this.acOpen = true;
        });
      }, 220);
    },
    onLocKeydown(e) {
      if (e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      if (this.acMatches.length) {
        this.pickLocation(this.acMatches[0]);
      }
    },
    pickLocation(item) {
      this.$emit('update:locationId', +item.id);
      this.$emit('update:locationLabel', item.city);
      this.acOpen = false;
      this.locHelper = 'Ausgewählt: ' + item.city;
      this.$emit('picked');
    },
    loadLocations() {
      if (this.locationsLoaded) {
        return Promise.resolve(this.locations);
      }
      if (this.locationsLoading) {
        return this.locationsLoading;
      }
      if (!this.$store || !this.$store.dispatch) {
        this.locations = FALLBACK_LOCATIONS.slice();
        this.locationsLoaded = true;
        return Promise.resolve(this.locations);
      }
      this.locationsLoading = this.$store
        .dispatch('locations/load')
        .then(() => {
          this.locations = (this.$store.getters && this.$store.getters['locations/getLocations']) || [];
          this.locationsLoaded = true;
          return this.locations;
        })
        .catch((err) => {
          console.warn('Konnte Orte nicht laden:', err);
          this.locations = FALLBACK_LOCATIONS.slice();
          this.locationsLoaded = true;
          return this.locations;
        });
      return this.locationsLoading;
    },
    onDocClick(e) {
      if (!e.target.closest('.lk-card .ac-wrap')) {
        this.acOpen = false;
      }
    },
  },
};
</script>
